"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSouthDakotaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'SD';

function getSouthDakotaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Wages - 80% or 40 times federal min wage unless supporting dependants',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 15-20-12; S.D. Codified Laws Ann. § 21-18-52',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES;
    },
    transformFromContext: function transformFromContext() {// Wages for support - 50% exempt if supporting other child/spouse, 40% if not
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 23A-28B-24',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Assistance',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 28-7A-18',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 3-12-115',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.PUBLIC_EMPLOYEE_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, // NOTE: FFFF. Employee benefits seems like a broad category that should already exist...
  // {
  //   id: idCounter.increment(),
  //   description: 'Employee Benefit Plans',
  //   type: stateCode,
  //   statuteName: 'S.D. Codified Laws Ann. § 28-7A-18',
  //   limitAggregateSingle: Number.MAX_SAFE_INTEGER,
  //   limitAggregateJoint: Number.MAX_SAFE_INTEGER,
  //   limitPerItem: Number.MAX_SAFE_INTEGER,
  //   assetLimit: Number.MAX_SAFE_INTEGER,
  //   canApply(asset: Asset) {
  //     const subType = _.get(asset, 'assetJSON.subType');
  //     return this.canTakeMoreExemptions()
  //       && subType === EMPLOYEE_BENEFITS;
  //   },
  // },
  {
    id: idCounter.increment(),
    description: 'ERISA (employee retirement account)',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-16; S.D. Codified Laws Ann. § 43-45-17',
    limitAggregateSingle: 1000000,
    limitAggregateJoint: 2000000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.ERISA_REITREMENT_PLAN];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA & Roth IRA',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-16; S.D. Codified Laws Ann. § 43-45-17',
    limitAggregateSingle: 1245475,
    limitAggregateJoint: 2490950,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.IRA);
    }
  }, {
    id: idCounter.increment(),
    description: 'Family Pictures',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-2 (1)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FAMILY_PHOTOS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Books',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-2 (4)',
    limitAggregateSingle: 200,
    limitAggregateJoint: 400,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.BOOK;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wearing Apparel',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-2 (5)',
    limitAggregateSingle: 2000,
    limitAggregateJoint: 4000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CLOTHES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Food and Fuel to last 1 year',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-2 (6)',
    limitAggregateSingle: 600,
    limitAggregateJoint: 1200,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FOOD_AND_FUEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony or Maintenance Support',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-2 (9)',
    limitAggregateSingle: 750,
    limitAggregateJoint: 1500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Life insurance (spouse, child)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-6',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-5-2 (8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds (cash value)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 58-12-4',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, // NOTE: Difference here???
  // {
  //   id: idCounter.increment(),
  //   description: 'Life Insurance (if clause prohibits)',
  //   type: stateCode,
  //   statuteName: 'S.D. Codified Laws Ann. § 58-15-70',
  //   limitAggregateSingle: Number.MAX_SAFE_INTEGER,
  //   limitAggregateJoint: Number.MAX_SAFE_INTEGER,
  //   limitPerItem: Number.MAX_SAFE_INTEGER,
  //   assetLimit: Number.MAX_SAFE_INTEGER,
  //   canApply(asset: Asset) {
  //     const tertiaryType = _.get(asset, 'assetJSON.tertiaryType');
  //     return this.canTakeMoreExemptions()
  //       && tertiaryType === LIFE_INSURANCE_PLAN;
  //   },
  // },
  {
    id: idCounter.increment(),
    description: 'Annuities - $250 per month',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 58-12-6; S.D. Codified Laws Ann. § 58-12-8',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ANNUITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 58-37A-18',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 61-6-48',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 62-4-42',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'City Employees',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 9-16-47',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.MUNICIPAL_EMPLOYEES_PENSION;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'S.D. Codified Laws Ann. § 43-45-4',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    },
    transformFromContext: function transformFromContext(caseObj) {
      // If "head of household" (imo, has dependents)
      if (_lodash["default"].get(caseObj, 'household.dependents', []).length > 0) {
        this.description = 'Wildcard Exemption (head of family)';
        this.statuteName = 'S.D. Codified Laws Ann. § 43-45-4';
        this.limitAggregateSingle = 7000;
        this.limitAggregateJoint = 14000;
      }
    }
  }];
}